import styled, { css } from 'styled-components';
import { BUTTON_SIZE, BUTTON_SIZE_WIDTH_MAP } from '@/config/ui/button';
import { PALETTE_COLORS } from '@/constant/unit/color';
import { DEVICE } from '@/constant/unit/device';
const generalButtonStyle = css `
  position: relative;

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: ${(props) => BUTTON_SIZE_WIDTH_MAP[props.size]};
  padding: ${(props) => (props.size === BUTTON_SIZE.AUTO ? `0 12px` : 0)};
  overflow: hidden;

  font-size: 18px;
  font-weight: 700;

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  @media ${DEVICE.mobileM} {
    font-size: 20px;
  }

  &:active {
    box-shadow: 0 4px 12px rgb(51 51 51 / 25%);
  }
`;
// Primary & Secondary Button
const generalPrimaryAndSecondaryButtonStyle = css `
  ${generalButtonStyle};
  height: 54px;
  border: ${(props) => {
    if (props.disabled)
        return `2px solid ${PALETTE_COLORS.NEUTRAL_800}`;
    return `2px solid ${PALETTE_COLORS.PRIMARY_900}`;
}};
  border-radius: 43px;
`;
const primaryButtonStyle = css `
  ${generalPrimaryAndSecondaryButtonStyle};

  color: ${PALETTE_COLORS.NEUTRAL_300};
  background: ${(props) => props.disabled ? PALETTE_COLORS.NEUTRAL_800 : PALETTE_COLORS.PRIMARY_900};
`;
const secondaryButtonStyle = css `
  ${generalPrimaryAndSecondaryButtonStyle};
  color: ${PALETTE_COLORS.NEUTRAL_900};
  background: none;
`;
// Back & Forward Button
// #NOTES
// Currently there are two versions of BackButton and ForwardButton in our codebase.
// The main difference is based on the button color:
// v1 - PALETTE_COLORS.NEUTRAL_900; v2 - PALETTE_COLORS.PRIMARY_900.
const generalBackAndForwardButtonStyle = css `
  ${generalButtonStyle};
  height: 41px;
  border: ${(props) => {
    if (props.disabled)
        return `2px solid ${PALETTE_COLORS.NEUTRAL_800}`;
    return `2px solid ${props.isV2 ? PALETTE_COLORS.PRIMARY_900 : PALETTE_COLORS.NEUTRAL_900}`;
}};
  border-radius: 21.5px;
`;
const forwardButtonStyle = css `
  ${generalBackAndForwardButtonStyle};
  color: ${PALETTE_COLORS.NEUTRAL_300};
  background: ${(props) => {
    if (props.disabled)
        return PALETTE_COLORS.NEUTRAL_800;
    return props.isV2 ? PALETTE_COLORS.PRIMARY_900 : PALETTE_COLORS.NEUTRAL_900;
}};
`;
const backButtonStyle = css `
  ${generalBackAndForwardButtonStyle};
  color: ${(props) => (props.isV2 ? PALETTE_COLORS.PRIMARY_900 : PALETTE_COLORS.NEUTRAL_900)};
  background: none;
`;
export const S = {
    PrimaryButton: styled.button `
    ${primaryButtonStyle};
  `,
    PrimaryButtonLink: styled.a `
    ${primaryButtonStyle};
  `,
    SecondaryButton: styled.button `
    ${secondaryButtonStyle};
  `,
    SecondaryButtonLink: styled.a `
    ${secondaryButtonStyle};
  `,
    ForwardButton: styled.button `
    ${forwardButtonStyle};
  `,
    ForwardButtonLink: styled.a `
    ${forwardButtonStyle};
  `,
    BackButton: styled.button `
    ${backButtonStyle};
  `,
    BackButtonLink: styled.a `
    ${backButtonStyle};
  `,
    // loading
    Loading: styled.div `
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
  `,
};
